import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const AddEmployeeTabs = ({ toggleTab, activeTab }) => {
  console.log("active tab is", activeTab);
  return (
    <Nav
      className="nav-tabs-custom mb-3 ms-n3 card-header-tabs border-bottom-0"
      role="tablist"
    >
      <NavItem className="mx-3">
        <NavLink
          className={classnames(
            {
              active: activeTab === "manual",
              "fw-semibold": activeTab === "manual",
            },
            "p-2 text-primary"
          )}
          onClick={() => {
            toggleTab("manual", "manual");
          }}
          href="#"
        >
          Manual Entry
        </NavLink>
      </NavItem>
      <NavItem className="mx-3">
        <NavLink
          className={classnames(
            {
              active: activeTab === "csv",
              "fw-semibold": activeTab === "csv",
            },
            "p-2 text-primary"
          )}
          onClick={() => {
            toggleTab("csv", "csv");
          }}
          href="#"
        >
          From CSV
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default AddEmployeeTabs;
